/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as TrackingRouteImport } from './routes/tracking'
import { Route as SlotRouteImport } from './routes/slot'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RbacRouteImport } from './routes/rbac'
import { Route as MerchantsRouteImport } from './routes/merchants'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IntegrationTokensRouteImport } from './routes/integration-tokens'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as DispatchRouteImport } from './routes/dispatch'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as CouriersIndexRouteImport } from './routes/couriers/index'
import { Route as StorefrontRestaurantsRouteImport } from './routes/storefront/restaurants'
import { Route as StorefrontPromotionsRouteImport } from './routes/storefront/promotions'
import { Route as StorefrontProductsRouteImport } from './routes/storefront/products'
import { Route as StorefrontCategoriesRouteImport } from './routes/storefront/categories'
import { Route as SettingsServicesRouteImport } from './routes/settings/services'
import { Route as SettingsMultiorderRouteImport } from './routes/settings/multiorder'
import { Route as SettingsEtaRouteImport } from './routes/settings/eta'
import { Route as SettingsDeliveryRouteImport } from './routes/settings/delivery'
import { Route as SettingsCitiesRouteImport } from './routes/settings/cities'
import { Route as ReportsTransactionsRouteImport } from './routes/reports/transactions'
import { Route as ReportsSelfEmployedRouteImport } from './routes/reports/self-employed'
import { Route as OrdersOrderIdRouteImport } from './routes/orders/$orderId'
import { Route as ModerationRestaurantsRouteImport } from './routes/moderation/restaurants'
import { Route as ModerationPromotionsRouteImport } from './routes/moderation/promotions'
import { Route as ModerationProductsRouteImport } from './routes/moderation/products'
import { Route as ModerationCategoriesRouteImport } from './routes/moderation/categories'
import { Route as MerchantsMerchantIdRouteImport } from './routes/merchants/$merchantId'
import { Route as FoodOrdersRouteImport } from './routes/food/orders'
import { Route as CouriersCourierIdRouteImport } from './routes/couriers/$courierId'
import { Route as CatalogRestaurantsRouteImport } from './routes/catalog/restaurants'
import { Route as CatalogPromotionsRouteImport } from './routes/catalog/promotions'
import { Route as CatalogProductsRouteImport } from './routes/catalog/products'
import { Route as CatalogCategoriesRouteImport } from './routes/catalog/categories'
import { Route as BusinessRestaurantBannersRouteImport } from './routes/business/restaurant-banners'
import { Route as BusinessProductBannersRouteImport } from './routes/business/product-banners'
import { Route as BusinessCuisinesRouteImport } from './routes/business/cuisines'
import { Route as BusinessCategoriesRouteImport } from './routes/business/categories'
import { Route as BusinessBannersRouteImport } from './routes/business/banners'
import { Route as OrdersOrderIdIndexRouteImport } from './routes/orders/$orderId.index'
import { Route as OrdersOrderIdEditRouteImport } from './routes/orders/$orderId/edit'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackingRoute = TrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => rootRouteImport,
} as any)
const SlotRoute = SlotRouteImport.update({
  id: '/slot',
  path: '/slot',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RbacRoute = RbacRouteImport.update({
  id: '/rbac',
  path: '/rbac',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsRoute = MerchantsRouteImport.update({
  id: '/merchants',
  path: '/merchants',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationTokensRoute = IntegrationTokensRouteImport.update({
  id: '/integration-tokens',
  path: '/integration-tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const DispatchRoute = DispatchRouteImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const CouriersIndexRoute = CouriersIndexRouteImport.update({
  id: '/couriers/',
  path: '/couriers/',
  getParentRoute: () => rootRouteImport,
} as any)
const StorefrontRestaurantsRoute = StorefrontRestaurantsRouteImport.update({
  id: '/storefront/restaurants',
  path: '/storefront/restaurants',
  getParentRoute: () => rootRouteImport,
} as any)
const StorefrontPromotionsRoute = StorefrontPromotionsRouteImport.update({
  id: '/storefront/promotions',
  path: '/storefront/promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const StorefrontProductsRoute = StorefrontProductsRouteImport.update({
  id: '/storefront/products',
  path: '/storefront/products',
  getParentRoute: () => rootRouteImport,
} as any)
const StorefrontCategoriesRoute = StorefrontCategoriesRouteImport.update({
  id: '/storefront/categories',
  path: '/storefront/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsServicesRoute = SettingsServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMultiorderRoute = SettingsMultiorderRouteImport.update({
  id: '/multiorder',
  path: '/multiorder',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEtaRoute = SettingsEtaRouteImport.update({
  id: '/eta',
  path: '/eta',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDeliveryRoute = SettingsDeliveryRouteImport.update({
  id: '/delivery',
  path: '/delivery',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCitiesRoute = SettingsCitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => SettingsRoute,
} as any)
const ReportsTransactionsRoute = ReportsTransactionsRouteImport.update({
  id: '/reports/transactions',
  path: '/reports/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsSelfEmployedRoute = ReportsSelfEmployedRouteImport.update({
  id: '/reports/self-employed',
  path: '/reports/self-employed',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationRestaurantsRoute = ModerationRestaurantsRouteImport.update({
  id: '/moderation/restaurants',
  path: '/moderation/restaurants',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationPromotionsRoute = ModerationPromotionsRouteImport.update({
  id: '/moderation/promotions',
  path: '/moderation/promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationProductsRoute = ModerationProductsRouteImport.update({
  id: '/moderation/products',
  path: '/moderation/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationCategoriesRoute = ModerationCategoriesRouteImport.update({
  id: '/moderation/categories',
  path: '/moderation/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsMerchantIdRoute = MerchantsMerchantIdRouteImport.update({
  id: '/$merchantId',
  path: '/$merchantId',
  getParentRoute: () => MerchantsRoute,
} as any)
const FoodOrdersRoute = FoodOrdersRouteImport.update({
  id: '/food/orders',
  path: '/food/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const CouriersCourierIdRoute = CouriersCourierIdRouteImport.update({
  id: '/couriers/$courierId',
  path: '/couriers/$courierId',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRestaurantsRoute = CatalogRestaurantsRouteImport.update({
  id: '/catalog/restaurants',
  path: '/catalog/restaurants',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogPromotionsRoute = CatalogPromotionsRouteImport.update({
  id: '/catalog/promotions',
  path: '/catalog/promotions',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogProductsRoute = CatalogProductsRouteImport.update({
  id: '/catalog/products',
  path: '/catalog/products',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogCategoriesRoute = CatalogCategoriesRouteImport.update({
  id: '/catalog/categories',
  path: '/catalog/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessRestaurantBannersRoute =
  BusinessRestaurantBannersRouteImport.update({
    id: '/business/restaurant-banners',
    path: '/business/restaurant-banners',
    getParentRoute: () => rootRouteImport,
  } as any)
const BusinessProductBannersRoute = BusinessProductBannersRouteImport.update({
  id: '/business/product-banners',
  path: '/business/product-banners',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessCuisinesRoute = BusinessCuisinesRouteImport.update({
  id: '/business/cuisines',
  path: '/business/cuisines',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessCategoriesRoute = BusinessCategoriesRouteImport.update({
  id: '/business/categories',
  path: '/business/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const BusinessBannersRoute = BusinessBannersRouteImport.update({
  id: '/business/banners',
  path: '/business/banners',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdIndexRoute = OrdersOrderIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrdersOrderIdRoute,
} as any)
const OrdersOrderIdEditRoute = OrdersOrderIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OrdersOrderIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/dispatch': typeof DispatchRoute
  '/forbidden': typeof ForbiddenRoute
  '/inbox': typeof InboxRoute
  '/integration-tokens': typeof IntegrationTokensRoute
  '/login': typeof LoginRoute
  '/merchants': typeof MerchantsRouteWithChildren
  '/rbac': typeof RbacRoute
  '/settings': typeof SettingsRouteWithChildren
  '/slot': typeof SlotRoute
  '/tracking': typeof TrackingRoute
  '/users': typeof UsersRoute
  '/business/banners': typeof BusinessBannersRoute
  '/business/categories': typeof BusinessCategoriesRoute
  '/business/cuisines': typeof BusinessCuisinesRoute
  '/business/product-banners': typeof BusinessProductBannersRoute
  '/business/restaurant-banners': typeof BusinessRestaurantBannersRoute
  '/catalog/categories': typeof CatalogCategoriesRoute
  '/catalog/products': typeof CatalogProductsRoute
  '/catalog/promotions': typeof CatalogPromotionsRoute
  '/catalog/restaurants': typeof CatalogRestaurantsRoute
  '/couriers/$courierId': typeof CouriersCourierIdRoute
  '/food/orders': typeof FoodOrdersRoute
  '/merchants/$merchantId': typeof MerchantsMerchantIdRoute
  '/moderation/categories': typeof ModerationCategoriesRoute
  '/moderation/products': typeof ModerationProductsRoute
  '/moderation/promotions': typeof ModerationPromotionsRoute
  '/moderation/restaurants': typeof ModerationRestaurantsRoute
  '/orders/$orderId': typeof OrdersOrderIdRouteWithChildren
  '/reports/self-employed': typeof ReportsSelfEmployedRoute
  '/reports/transactions': typeof ReportsTransactionsRoute
  '/settings/cities': typeof SettingsCitiesRoute
  '/settings/delivery': typeof SettingsDeliveryRoute
  '/settings/eta': typeof SettingsEtaRoute
  '/settings/multiorder': typeof SettingsMultiorderRoute
  '/settings/services': typeof SettingsServicesRoute
  '/storefront/categories': typeof StorefrontCategoriesRoute
  '/storefront/products': typeof StorefrontProductsRoute
  '/storefront/promotions': typeof StorefrontPromotionsRoute
  '/storefront/restaurants': typeof StorefrontRestaurantsRoute
  '/couriers/': typeof CouriersIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/orders/$orderId/edit': typeof OrdersOrderIdEditRoute
  '/orders/$orderId/': typeof OrdersOrderIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/dispatch': typeof DispatchRoute
  '/forbidden': typeof ForbiddenRoute
  '/inbox': typeof InboxRoute
  '/integration-tokens': typeof IntegrationTokensRoute
  '/login': typeof LoginRoute
  '/merchants': typeof MerchantsRouteWithChildren
  '/rbac': typeof RbacRoute
  '/settings': typeof SettingsRouteWithChildren
  '/slot': typeof SlotRoute
  '/tracking': typeof TrackingRoute
  '/users': typeof UsersRoute
  '/business/banners': typeof BusinessBannersRoute
  '/business/categories': typeof BusinessCategoriesRoute
  '/business/cuisines': typeof BusinessCuisinesRoute
  '/business/product-banners': typeof BusinessProductBannersRoute
  '/business/restaurant-banners': typeof BusinessRestaurantBannersRoute
  '/catalog/categories': typeof CatalogCategoriesRoute
  '/catalog/products': typeof CatalogProductsRoute
  '/catalog/promotions': typeof CatalogPromotionsRoute
  '/catalog/restaurants': typeof CatalogRestaurantsRoute
  '/couriers/$courierId': typeof CouriersCourierIdRoute
  '/food/orders': typeof FoodOrdersRoute
  '/merchants/$merchantId': typeof MerchantsMerchantIdRoute
  '/moderation/categories': typeof ModerationCategoriesRoute
  '/moderation/products': typeof ModerationProductsRoute
  '/moderation/promotions': typeof ModerationPromotionsRoute
  '/moderation/restaurants': typeof ModerationRestaurantsRoute
  '/reports/self-employed': typeof ReportsSelfEmployedRoute
  '/reports/transactions': typeof ReportsTransactionsRoute
  '/settings/cities': typeof SettingsCitiesRoute
  '/settings/delivery': typeof SettingsDeliveryRoute
  '/settings/eta': typeof SettingsEtaRoute
  '/settings/multiorder': typeof SettingsMultiorderRoute
  '/settings/services': typeof SettingsServicesRoute
  '/storefront/categories': typeof StorefrontCategoriesRoute
  '/storefront/products': typeof StorefrontProductsRoute
  '/storefront/promotions': typeof StorefrontPromotionsRoute
  '/storefront/restaurants': typeof StorefrontRestaurantsRoute
  '/couriers': typeof CouriersIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/orders/$orderId/edit': typeof OrdersOrderIdEditRoute
  '/orders/$orderId': typeof OrdersOrderIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/dispatch': typeof DispatchRoute
  '/forbidden': typeof ForbiddenRoute
  '/inbox': typeof InboxRoute
  '/integration-tokens': typeof IntegrationTokensRoute
  '/login': typeof LoginRoute
  '/merchants': typeof MerchantsRouteWithChildren
  '/rbac': typeof RbacRoute
  '/settings': typeof SettingsRouteWithChildren
  '/slot': typeof SlotRoute
  '/tracking': typeof TrackingRoute
  '/users': typeof UsersRoute
  '/business/banners': typeof BusinessBannersRoute
  '/business/categories': typeof BusinessCategoriesRoute
  '/business/cuisines': typeof BusinessCuisinesRoute
  '/business/product-banners': typeof BusinessProductBannersRoute
  '/business/restaurant-banners': typeof BusinessRestaurantBannersRoute
  '/catalog/categories': typeof CatalogCategoriesRoute
  '/catalog/products': typeof CatalogProductsRoute
  '/catalog/promotions': typeof CatalogPromotionsRoute
  '/catalog/restaurants': typeof CatalogRestaurantsRoute
  '/couriers/$courierId': typeof CouriersCourierIdRoute
  '/food/orders': typeof FoodOrdersRoute
  '/merchants/$merchantId': typeof MerchantsMerchantIdRoute
  '/moderation/categories': typeof ModerationCategoriesRoute
  '/moderation/products': typeof ModerationProductsRoute
  '/moderation/promotions': typeof ModerationPromotionsRoute
  '/moderation/restaurants': typeof ModerationRestaurantsRoute
  '/orders/$orderId': typeof OrdersOrderIdRouteWithChildren
  '/reports/self-employed': typeof ReportsSelfEmployedRoute
  '/reports/transactions': typeof ReportsTransactionsRoute
  '/settings/cities': typeof SettingsCitiesRoute
  '/settings/delivery': typeof SettingsDeliveryRoute
  '/settings/eta': typeof SettingsEtaRoute
  '/settings/multiorder': typeof SettingsMultiorderRoute
  '/settings/services': typeof SettingsServicesRoute
  '/storefront/categories': typeof StorefrontCategoriesRoute
  '/storefront/products': typeof StorefrontProductsRoute
  '/storefront/promotions': typeof StorefrontPromotionsRoute
  '/storefront/restaurants': typeof StorefrontRestaurantsRoute
  '/couriers/': typeof CouriersIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/orders/$orderId/edit': typeof OrdersOrderIdEditRoute
  '/orders/$orderId/': typeof OrdersOrderIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/dispatch'
    | '/forbidden'
    | '/inbox'
    | '/integration-tokens'
    | '/login'
    | '/merchants'
    | '/rbac'
    | '/settings'
    | '/slot'
    | '/tracking'
    | '/users'
    | '/business/banners'
    | '/business/categories'
    | '/business/cuisines'
    | '/business/product-banners'
    | '/business/restaurant-banners'
    | '/catalog/categories'
    | '/catalog/products'
    | '/catalog/promotions'
    | '/catalog/restaurants'
    | '/couriers/$courierId'
    | '/food/orders'
    | '/merchants/$merchantId'
    | '/moderation/categories'
    | '/moderation/products'
    | '/moderation/promotions'
    | '/moderation/restaurants'
    | '/orders/$orderId'
    | '/reports/self-employed'
    | '/reports/transactions'
    | '/settings/cities'
    | '/settings/delivery'
    | '/settings/eta'
    | '/settings/multiorder'
    | '/settings/services'
    | '/storefront/categories'
    | '/storefront/products'
    | '/storefront/promotions'
    | '/storefront/restaurants'
    | '/couriers/'
    | '/orders/'
    | '/orders/$orderId/edit'
    | '/orders/$orderId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/dispatch'
    | '/forbidden'
    | '/inbox'
    | '/integration-tokens'
    | '/login'
    | '/merchants'
    | '/rbac'
    | '/settings'
    | '/slot'
    | '/tracking'
    | '/users'
    | '/business/banners'
    | '/business/categories'
    | '/business/cuisines'
    | '/business/product-banners'
    | '/business/restaurant-banners'
    | '/catalog/categories'
    | '/catalog/products'
    | '/catalog/promotions'
    | '/catalog/restaurants'
    | '/couriers/$courierId'
    | '/food/orders'
    | '/merchants/$merchantId'
    | '/moderation/categories'
    | '/moderation/products'
    | '/moderation/promotions'
    | '/moderation/restaurants'
    | '/reports/self-employed'
    | '/reports/transactions'
    | '/settings/cities'
    | '/settings/delivery'
    | '/settings/eta'
    | '/settings/multiorder'
    | '/settings/services'
    | '/storefront/categories'
    | '/storefront/products'
    | '/storefront/promotions'
    | '/storefront/restaurants'
    | '/couriers'
    | '/orders'
    | '/orders/$orderId/edit'
    | '/orders/$orderId'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/dispatch'
    | '/forbidden'
    | '/inbox'
    | '/integration-tokens'
    | '/login'
    | '/merchants'
    | '/rbac'
    | '/settings'
    | '/slot'
    | '/tracking'
    | '/users'
    | '/business/banners'
    | '/business/categories'
    | '/business/cuisines'
    | '/business/product-banners'
    | '/business/restaurant-banners'
    | '/catalog/categories'
    | '/catalog/products'
    | '/catalog/promotions'
    | '/catalog/restaurants'
    | '/couriers/$courierId'
    | '/food/orders'
    | '/merchants/$merchantId'
    | '/moderation/categories'
    | '/moderation/products'
    | '/moderation/promotions'
    | '/moderation/restaurants'
    | '/orders/$orderId'
    | '/reports/self-employed'
    | '/reports/transactions'
    | '/settings/cities'
    | '/settings/delivery'
    | '/settings/eta'
    | '/settings/multiorder'
    | '/settings/services'
    | '/storefront/categories'
    | '/storefront/products'
    | '/storefront/promotions'
    | '/storefront/restaurants'
    | '/couriers/'
    | '/orders/'
    | '/orders/$orderId/edit'
    | '/orders/$orderId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  DispatchRoute: typeof DispatchRoute
  ForbiddenRoute: typeof ForbiddenRoute
  InboxRoute: typeof InboxRoute
  IntegrationTokensRoute: typeof IntegrationTokensRoute
  LoginRoute: typeof LoginRoute
  MerchantsRoute: typeof MerchantsRouteWithChildren
  RbacRoute: typeof RbacRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SlotRoute: typeof SlotRoute
  TrackingRoute: typeof TrackingRoute
  UsersRoute: typeof UsersRoute
  BusinessBannersRoute: typeof BusinessBannersRoute
  BusinessCategoriesRoute: typeof BusinessCategoriesRoute
  BusinessCuisinesRoute: typeof BusinessCuisinesRoute
  BusinessProductBannersRoute: typeof BusinessProductBannersRoute
  BusinessRestaurantBannersRoute: typeof BusinessRestaurantBannersRoute
  CatalogCategoriesRoute: typeof CatalogCategoriesRoute
  CatalogProductsRoute: typeof CatalogProductsRoute
  CatalogPromotionsRoute: typeof CatalogPromotionsRoute
  CatalogRestaurantsRoute: typeof CatalogRestaurantsRoute
  CouriersCourierIdRoute: typeof CouriersCourierIdRoute
  FoodOrdersRoute: typeof FoodOrdersRoute
  ModerationCategoriesRoute: typeof ModerationCategoriesRoute
  ModerationProductsRoute: typeof ModerationProductsRoute
  ModerationPromotionsRoute: typeof ModerationPromotionsRoute
  ModerationRestaurantsRoute: typeof ModerationRestaurantsRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRouteWithChildren
  ReportsSelfEmployedRoute: typeof ReportsSelfEmployedRoute
  ReportsTransactionsRoute: typeof ReportsTransactionsRoute
  StorefrontCategoriesRoute: typeof StorefrontCategoriesRoute
  StorefrontProductsRoute: typeof StorefrontProductsRoute
  StorefrontPromotionsRoute: typeof StorefrontPromotionsRoute
  StorefrontRestaurantsRoute: typeof StorefrontRestaurantsRoute
  CouriersIndexRoute: typeof CouriersIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracking': {
      id: '/tracking'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof TrackingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slot': {
      id: '/slot'
      path: '/slot'
      fullPath: '/slot'
      preLoaderRoute: typeof SlotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rbac': {
      id: '/rbac'
      path: '/rbac'
      fullPath: '/rbac'
      preLoaderRoute: typeof RbacRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants': {
      id: '/merchants'
      path: '/merchants'
      fullPath: '/merchants'
      preLoaderRoute: typeof MerchantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integration-tokens': {
      id: '/integration-tokens'
      path: '/integration-tokens'
      fullPath: '/integration-tokens'
      preLoaderRoute: typeof IntegrationTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dispatch': {
      id: '/dispatch'
      path: '/dispatch'
      fullPath: '/dispatch'
      preLoaderRoute: typeof DispatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/couriers/': {
      id: '/couriers/'
      path: '/couriers'
      fullPath: '/couriers/'
      preLoaderRoute: typeof CouriersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storefront/restaurants': {
      id: '/storefront/restaurants'
      path: '/storefront/restaurants'
      fullPath: '/storefront/restaurants'
      preLoaderRoute: typeof StorefrontRestaurantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storefront/promotions': {
      id: '/storefront/promotions'
      path: '/storefront/promotions'
      fullPath: '/storefront/promotions'
      preLoaderRoute: typeof StorefrontPromotionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storefront/products': {
      id: '/storefront/products'
      path: '/storefront/products'
      fullPath: '/storefront/products'
      preLoaderRoute: typeof StorefrontProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storefront/categories': {
      id: '/storefront/categories'
      path: '/storefront/categories'
      fullPath: '/storefront/categories'
      preLoaderRoute: typeof StorefrontCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/services': {
      id: '/settings/services'
      path: '/services'
      fullPath: '/settings/services'
      preLoaderRoute: typeof SettingsServicesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/multiorder': {
      id: '/settings/multiorder'
      path: '/multiorder'
      fullPath: '/settings/multiorder'
      preLoaderRoute: typeof SettingsMultiorderRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/eta': {
      id: '/settings/eta'
      path: '/eta'
      fullPath: '/settings/eta'
      preLoaderRoute: typeof SettingsEtaRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/delivery': {
      id: '/settings/delivery'
      path: '/delivery'
      fullPath: '/settings/delivery'
      preLoaderRoute: typeof SettingsDeliveryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/cities': {
      id: '/settings/cities'
      path: '/cities'
      fullPath: '/settings/cities'
      preLoaderRoute: typeof SettingsCitiesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/reports/transactions': {
      id: '/reports/transactions'
      path: '/reports/transactions'
      fullPath: '/reports/transactions'
      preLoaderRoute: typeof ReportsTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/self-employed': {
      id: '/reports/self-employed'
      path: '/reports/self-employed'
      fullPath: '/reports/self-employed'
      preLoaderRoute: typeof ReportsSelfEmployedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation/restaurants': {
      id: '/moderation/restaurants'
      path: '/moderation/restaurants'
      fullPath: '/moderation/restaurants'
      preLoaderRoute: typeof ModerationRestaurantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation/promotions': {
      id: '/moderation/promotions'
      path: '/moderation/promotions'
      fullPath: '/moderation/promotions'
      preLoaderRoute: typeof ModerationPromotionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation/products': {
      id: '/moderation/products'
      path: '/moderation/products'
      fullPath: '/moderation/products'
      preLoaderRoute: typeof ModerationProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation/categories': {
      id: '/moderation/categories'
      path: '/moderation/categories'
      fullPath: '/moderation/categories'
      preLoaderRoute: typeof ModerationCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/$merchantId': {
      id: '/merchants/$merchantId'
      path: '/$merchantId'
      fullPath: '/merchants/$merchantId'
      preLoaderRoute: typeof MerchantsMerchantIdRouteImport
      parentRoute: typeof MerchantsRoute
    }
    '/food/orders': {
      id: '/food/orders'
      path: '/food/orders'
      fullPath: '/food/orders'
      preLoaderRoute: typeof FoodOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/couriers/$courierId': {
      id: '/couriers/$courierId'
      path: '/couriers/$courierId'
      fullPath: '/couriers/$courierId'
      preLoaderRoute: typeof CouriersCourierIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/restaurants': {
      id: '/catalog/restaurants'
      path: '/catalog/restaurants'
      fullPath: '/catalog/restaurants'
      preLoaderRoute: typeof CatalogRestaurantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/promotions': {
      id: '/catalog/promotions'
      path: '/catalog/promotions'
      fullPath: '/catalog/promotions'
      preLoaderRoute: typeof CatalogPromotionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/products': {
      id: '/catalog/products'
      path: '/catalog/products'
      fullPath: '/catalog/products'
      preLoaderRoute: typeof CatalogProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/categories': {
      id: '/catalog/categories'
      path: '/catalog/categories'
      fullPath: '/catalog/categories'
      preLoaderRoute: typeof CatalogCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/restaurant-banners': {
      id: '/business/restaurant-banners'
      path: '/business/restaurant-banners'
      fullPath: '/business/restaurant-banners'
      preLoaderRoute: typeof BusinessRestaurantBannersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/product-banners': {
      id: '/business/product-banners'
      path: '/business/product-banners'
      fullPath: '/business/product-banners'
      preLoaderRoute: typeof BusinessProductBannersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/cuisines': {
      id: '/business/cuisines'
      path: '/business/cuisines'
      fullPath: '/business/cuisines'
      preLoaderRoute: typeof BusinessCuisinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/categories': {
      id: '/business/categories'
      path: '/business/categories'
      fullPath: '/business/categories'
      preLoaderRoute: typeof BusinessCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/business/banners': {
      id: '/business/banners'
      path: '/business/banners'
      fullPath: '/business/banners'
      preLoaderRoute: typeof BusinessBannersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId/': {
      id: '/orders/$orderId/'
      path: '/'
      fullPath: '/orders/$orderId/'
      preLoaderRoute: typeof OrdersOrderIdIndexRouteImport
      parentRoute: typeof OrdersOrderIdRoute
    }
    '/orders/$orderId/edit': {
      id: '/orders/$orderId/edit'
      path: '/edit'
      fullPath: '/orders/$orderId/edit'
      preLoaderRoute: typeof OrdersOrderIdEditRouteImport
      parentRoute: typeof OrdersOrderIdRoute
    }
  }
}

interface MerchantsRouteChildren {
  MerchantsMerchantIdRoute: typeof MerchantsMerchantIdRoute
}

const MerchantsRouteChildren: MerchantsRouteChildren = {
  MerchantsMerchantIdRoute: MerchantsMerchantIdRoute,
}

const MerchantsRouteWithChildren = MerchantsRoute._addFileChildren(
  MerchantsRouteChildren,
)

interface SettingsRouteChildren {
  SettingsCitiesRoute: typeof SettingsCitiesRoute
  SettingsDeliveryRoute: typeof SettingsDeliveryRoute
  SettingsEtaRoute: typeof SettingsEtaRoute
  SettingsMultiorderRoute: typeof SettingsMultiorderRoute
  SettingsServicesRoute: typeof SettingsServicesRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsCitiesRoute: SettingsCitiesRoute,
  SettingsDeliveryRoute: SettingsDeliveryRoute,
  SettingsEtaRoute: SettingsEtaRoute,
  SettingsMultiorderRoute: SettingsMultiorderRoute,
  SettingsServicesRoute: SettingsServicesRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface OrdersOrderIdRouteChildren {
  OrdersOrderIdEditRoute: typeof OrdersOrderIdEditRoute
  OrdersOrderIdIndexRoute: typeof OrdersOrderIdIndexRoute
}

const OrdersOrderIdRouteChildren: OrdersOrderIdRouteChildren = {
  OrdersOrderIdEditRoute: OrdersOrderIdEditRoute,
  OrdersOrderIdIndexRoute: OrdersOrderIdIndexRoute,
}

const OrdersOrderIdRouteWithChildren = OrdersOrderIdRoute._addFileChildren(
  OrdersOrderIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  DispatchRoute: DispatchRoute,
  ForbiddenRoute: ForbiddenRoute,
  InboxRoute: InboxRoute,
  IntegrationTokensRoute: IntegrationTokensRoute,
  LoginRoute: LoginRoute,
  MerchantsRoute: MerchantsRouteWithChildren,
  RbacRoute: RbacRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SlotRoute: SlotRoute,
  TrackingRoute: TrackingRoute,
  UsersRoute: UsersRoute,
  BusinessBannersRoute: BusinessBannersRoute,
  BusinessCategoriesRoute: BusinessCategoriesRoute,
  BusinessCuisinesRoute: BusinessCuisinesRoute,
  BusinessProductBannersRoute: BusinessProductBannersRoute,
  BusinessRestaurantBannersRoute: BusinessRestaurantBannersRoute,
  CatalogCategoriesRoute: CatalogCategoriesRoute,
  CatalogProductsRoute: CatalogProductsRoute,
  CatalogPromotionsRoute: CatalogPromotionsRoute,
  CatalogRestaurantsRoute: CatalogRestaurantsRoute,
  CouriersCourierIdRoute: CouriersCourierIdRoute,
  FoodOrdersRoute: FoodOrdersRoute,
  ModerationCategoriesRoute: ModerationCategoriesRoute,
  ModerationProductsRoute: ModerationProductsRoute,
  ModerationPromotionsRoute: ModerationPromotionsRoute,
  ModerationRestaurantsRoute: ModerationRestaurantsRoute,
  OrdersOrderIdRoute: OrdersOrderIdRouteWithChildren,
  ReportsSelfEmployedRoute: ReportsSelfEmployedRoute,
  ReportsTransactionsRoute: ReportsTransactionsRoute,
  StorefrontCategoriesRoute: StorefrontCategoriesRoute,
  StorefrontProductsRoute: StorefrontProductsRoute,
  StorefrontPromotionsRoute: StorefrontPromotionsRoute,
  StorefrontRestaurantsRoute: StorefrontRestaurantsRoute,
  CouriersIndexRoute: CouriersIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
